export const scrollbarProcess = (scollbar) =>{
  const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  const scrolled = (winScroll / height) * 100;
  scollbar.style.width = scrolled + "%";
}